import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WelcomeComponent } from './welcome/welcome.component';
import { SignupComponent } from './auth/signup/signup.component';
import { LoginComponent } from './auth/login/login.component';
import { OrderComponent } from './order/order.component';
import { AuthGuard } from './auth/auth.guard';
import { OrderDetailsComponent } from './order/order-details/order-details.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { InvoiceDetailsComponent } from './invoice/invoice-details/invoice-details.component';
import { ProfileComponent } from './profile/profile.component';
import { ReservationComponent } from './reservation/reservation.component';
import { ReservationDetailsComponent } from './reservation/details/reservation-details/reservation-details.component';
import { DeliveryComponent } from './order/delivery/delivery.component';
import { DeliveryDetailsComponent } from './order/delivery/delivery-details/delivery-details.component';
import { OnSiteComponent } from './order/on-site/on-site.component';
import { OnSiteDetailsComponent } from './order/on-site/on-site-details/on-site-details.component';
import { PickupComponent } from './order/pickup/pickup.component';
import { PickupDetailsComponent } from './order/pickup/pickup-details/pickup-details.component';
import { Angulartics2Module } from 'angulartics2';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { MonerisComponent } from './moneris/moneris.component';
import { AccessComponent } from './access/access.component';
import { InvoiceV2Component } from './invoice-v2/invoice-v2.component';
import { OrderInvoiceListComponent } from './invoice-v2/order-invoice-list/order-invoice-list.component';
import { OrderInvoiceDetailComponent } from './invoice-v2/order-invoice-detail/order-invoice-detail.component';

const routes: Routes = [
  {path: '', redirectTo: '/dashboard', pathMatch: 'full'},
  {path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard], data: {animation: "isLeft"}},
  {path: 'signup', component: SignupComponent, data: {animation: "isLeft"}},
  {path: 'signup/:email', component: SignupComponent, data: {animation: "isLeft"}},
  {path: 'login', component: LoginComponent, data: {animation: "isRight"}},
  {path: 'forgot-password', component: ForgotPasswordComponent, data: {animation: "isLeft"}},
  {path: 'reset-password/:token', component: ResetPasswordComponent, data: {animation: "isLeft"}},
  {path: 'profile', component: ProfileComponent, canActivate: [AuthGuard], data: {animation: "isRight"}},
  {path: 'reservations', component: ReservationComponent, canActivate: [AuthGuard], data: {animation: "isRight"}},
  {path: 'reservations/:id', component: ReservationDetailsComponent, canActivate: [AuthGuard], data: {animation: "isRight"}},
  {path: 'invoices', component: InvoiceV2Component, canActivate: [AuthGuard], data: {animation: "isRight"}},
  {path: 'invoices/:id/invoice', component: OrderInvoiceListComponent, canActivate: [AuthGuard], data: {animation: "isRight"}},
  {path: 'invoices/:orderId/invoice/:invoiceId', component: OrderInvoiceDetailComponent, canActivate: [AuthGuard], data: {animation: "isRight"}},
  {path: 'invoices-legacy', component: InvoiceComponent, canActivate: [AuthGuard], data: {animation: "isRight"}},
  {path: 'invoices-legacy/:id/:type', component: InvoiceDetailsComponent, canActivate: [AuthGuard], data: {animation: "isRight"}},
  {path: 'delivery', component: DeliveryComponent, canActivate: [AuthGuard], data: {animation: "isRight"}},
  {path: 'delivery/:id', component: DeliveryDetailsComponent, canActivate: [AuthGuard], data: {animation: "isRight"}},
  {path: 'on-site', component: OnSiteComponent, canActivate: [AuthGuard], data: {animation: "isRight"}},
  {path: 'on-site/:id', component: OnSiteDetailsComponent, canActivate: [AuthGuard], data: {animation: "isRight"}},
  {path: 'pickup', component: PickupComponent, canActivate: [AuthGuard], data: {animation: "isRight"}},
  {path: 'pickup/:id', component: PickupDetailsComponent, canActivate: [AuthGuard], data: {animation: "isRight"}},
  {path: 'moneris', component: MonerisComponent,},
  {path: 'access', component: AccessComponent,}
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    Angulartics2Module.forRoot()
  ],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule {

}
